import { Pagination } from 'react-admin';

export const DefaultPagination = () => (
  <Pagination rowsPerPageOptions={[5, 10, 25, 50, 100]} />
);
